"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribedBalance = exports.SubscribedOrder = void 0;
const PUSHTypes_1 = require("../PUSHTypes");
class SubscribedOrder extends PUSHTypes_1.SubscribedObject {
    constructor(params) {
        super();
        this.orderId = params.orderId;
        this.selectionId = params.selectionId;
        this.punterReferenceNumber = params.punterReferenceNumber;
        this.status = params.status;
        this.issuedAt = params.issuedAt;
        this.lastChangedAt = params.lastChangedAt;
        this.expiresAt = params.expiresAt;
        this.requestedForSideStake = params.requestedForSideStake;
        this.requestedForSidePrice = params.requestedForSidePrice;
        this.orderFillType = params.orderFillType;
        this.fillOrKillThreshold = params.fillOrKillThreshold;
        this.expectedSelectionResetCount =
            params.expectedSelectionResetCount;
        this.expectedWithdrawalSequenceNumber =
            params.expectedWithdrawalSequenceNumber;
        this.totalForSideStake = Number(params.totalForSideStake || 0);
        this.forSideAmountUnmatched = params.forSideAmountUnmatched;
        this.totalAgainstSideStake = Number(params.totalAgainstSideStake || 0);
        this.totalForSideMakeStake = Number(params.totalForSideMakeStake || 0);
        this.totalForSideTakeStake = Number(params.totalForSideTakeStake || 0);
        this.polarity = params.polarity;
        this.cancelOnInRunning = params.cancelOnInRunning;
        this.cancelIfSelectionReset = params.cancelIfSelectionReset;
        this.isFreeBet = params.isFreeBet;
        this.willBeInRunning = params.willBeInRunning;
        this.commissionBasis = params.commissionBasis;
        this.makeCommissionRate = Number(params.makeCommissionRate || 0);
        this.takeCommissionRate = Number(params.takeCommissionRate || 0);
        this.grossSettlementAmount = Number(params.grossSettlementAmount || 0);
        this.orderCommission = Number(params.orderCommission || 0);
        this.marketId = params.marketId;
    }
    updateProperties(items) {
        for (const item in items) {
            switch (item) {
                case 'cancelIfSelectionReset':
                    this['cancelIfSelectionReset'] = Boolean(items[item]);
                    break;
                case 'cancelOnInRunning':
                    this['cancelOnInRunning'] = Boolean(items[item]);
                    break;
                case 'commissionBasis':
                    this['commissionBasis'] = Number(items[item]);
                    break;
                case 'expectedSelectionResetCount':
                    this['expectedSelectionResetCount'] = Number(items[item]);
                    break;
                case 'expectedWithdrawalSequenceNumber':
                    this['expectedWithdrawalSequenceNumber'] = Number(items[item]);
                    break;
                case 'fillOrKillThreshold':
                    this['fillOrKillThreshold'] = Number(items[item]);
                    break;
                case 'forSideAmountUnmatched':
                    this['forSideAmountUnmatched'] = Number(items[item]);
                    break;
                case 'grossSettlementAmount':
                    this['grossSettlementAmount'] = Number(items[item] || 0);
                    break;
                case 'makeCommissionRate':
                    this['makeCommissionRate'] = Number(items[item]);
                    break;
                case 'orderCommission':
                    this['orderCommission'] = Number(items[item] || 0);
                    break;
                case 'orderFillType':
                    this['orderFillType'] = Number(items[item]);
                    break;
                case 'punterReferenceNumber':
                    this['punterReferenceNumber'] = Number(items[item] || 0);
                    break;
                case 'requestedForSidePrice':
                    this['requestedForSidePrice'] = Number(items[item]);
                    break;
                case 'requestedForSideStake':
                    this['requestedForSideStake'] = Number(items[item]);
                    break;
                case 'status':
                    this['status'] = Number(items[item]);
                    break;
                case 'selectionId':
                    this['selectionId'] = Number(items[item]);
                    break;
                case 'requestedForSideStakxxxx':
                    this['requestedForSideStake'] = Number(items[item]);
                    break;
                case 'totalForSideTakeStake':
                    this['totalForSideTakeStake'] = Number(items[item] || 0);
                    break;
                case 'marketId':
                    this['marketId'] = Number(items[item]);
                    break;
            }
        }
    }
}
exports.SubscribedOrder = SubscribedOrder;
class SubscribedBalance extends PUSHTypes_1.SubscribedObject {
    constructor(params) {
        super();
        this.availableBalance = 0;
        this.withdrawableBalance = 0;
        this.lastUpdatedAt = '';
        this.currency = '';
        this.availableBalance = Number(params.availableBalance);
        this.withdrawableBalance = Number(params.withdrawableBalance);
        this.lastUpdatedAt = params.lastUpdatedAt;
        this.currency = params.currency;
    }
}
exports.SubscribedBalance = SubscribedBalance;
